export default "__VITE_ASSET__CKFh5vsA__"